var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClipboard = function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "clipboard_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgClipboard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTYgNEgxOEMxOC41MzA0IDQgMTkuMDM5MSA0LjIxMDcxIDE5LjQxNDIgNC41ODU3OUMxOS43ODkzIDQuOTYwODYgMjAgNS40Njk1NyAyMCA2VjIwQzIwIDIwLjUzMDQgMTkuNzg5MyAyMS4wMzkxIDE5LjQxNDIgMjEuNDE0MkMxOS4wMzkxIDIxLjc4OTMgMTguNTMwNCAyMiAxOCAyMkg2QzUuNDY5NTcgMjIgNC45NjA4NiAyMS43ODkzIDQuNTg1NzkgMjEuNDE0MkM0LjIxMDcxIDIxLjAzOTEgNCAyMC41MzA0IDQgMjBWNkM0IDUuNDY5NTcgNC4yMTA3MSA0Ljk2MDg2IDQuNTg1NzkgNC41ODU3OUM0Ljk2MDg2IDQuMjEwNzEgNS40Njk1NyA0IDYgNEg4IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNMTUgMkg5QzguNDQ3NzIgMiA4IDIuNDQ3NzIgOCAzVjVDOCA1LjU1MjI4IDguNDQ3NzIgNiA5IDZIMTVDMTUuNTUyMyA2IDE2IDUuNTUyMjggMTYgNVYzQzE2IDIuNDQ3NzIgMTUuNTUyMyAyIDE1IDJaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";